'use strict';
import React from 'react';
import { TweenMax, TimelineMax, EasePack, TextPlugin} from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import settings from '../../util/settings';
import data from '../../static/json/data.json';
import Title from '../../components/Title/Title';
import Feature from '../../components/Feature/Feature';

// {
//   "name": "Bending",
//   "description": "Smooth bends for all your sheet metal bending needs",
//   "image": "services/bending.jpg"
// },
// {
//   "name": "Flame Cutting",
//   "description": "If saw cutting doesn't suit your application, we also offer flame cutting",
//   "image": "services/flame-cutting.jpg"
// }, 

class Services extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    }
    this.AnimationElements = []
  }
  componentDidMount() {
    TweenMax.to(this.container, 0.5, {autoAlpha: 1});
    TweenMax.set(this.AnimationElements, {autoAlpha: 0});
    this.animateIn();

    this.props.refSetter(this.container)
  }
  componentWillUnmount() {
    TweenMax.set(this.container, {autoAlpha: 0});
  }
  animateIn = () => {
    var tl = new TimelineMax({paused: true, delay: 0.5});
    tl.staggerFromTo(this.AnimationElements, 2, {autoAlpha: 0, y: 50}, {autoAlpha: 1, y: 0, ease: Expo.easeOut}, 0.25);
    tl.play();
  }
  render() {
    this.AnimationElements = []
    return <div
      id="section-services"
      ref={el => this.container = el}
    >
      <div className="ContentContainer">
        <Title title="SERVICES" subtitle="We offer a wide range of services including, but not limited to, the following" />
        <div className="row services-container">
          { data && data.services &&
            data.services.map((item, index) => {
              return <Feature className="col-6 col-md-4 notClickable" title={item.name}
                              subtitle={item.description} image={item.image} key={index} />
            })
          }
        </div>
      </div>
    </div>;
  }
};

Services.defaultProps = {
  windowWidth: 960,
  windowHeight: 570
};

export default Services;



// WEBPACK FOOTER //
// ./sections/Services/Services.js